
export const zStudentLabel = (order) => {
    const { student } = order

    let fontSize = 48
    let top = 36

    if (student.length > 14) {
        fontSize = 30
        top = 45
    }

    // if (student.length > 20) {
    //     fontSize = 24
    //     top = 50
    // }

    const WIDTH = 400

    return `
^CI28
^FO0,${top}^FB${WIDTH},2,1,C^A0,${fontSize},${fontSize}^FD${student}^FS
^FO385,${top}^FB${WIDTH},2,1,C^A0,${fontSize},${fontSize}^FD${student}^FS 
`
}